import { ValidOption } from '../../../core/components/validation/types';
import { validPropDroplistTextVM } from '../../../core/components/validation/ValidInputDroplistText';
import { validPropRadioTextVM } from '../../../core/components/validation/ValidInputRadioText';
import { validPropTextVM } from '../../../core/components/validation/ValidInputText';
import { validPropMultiTextFieldVM } from '../../../core/components/validation/ValidMultiFieldText';
import { EditStateVendor, VendorEditPageState } from './vendor_edit_types';
import { AdminVendorModel } from '../vendor_types';

const statusOptions = [
    { lbl: 'Active', val: 'ACTIVE' },
    { lbl: 'Inactive', val: 'INACTIVE' },
];

const typeOptions = [
    { lbl: 'WHOLESALER', val: 'WHOLESALER' },
    { lbl: 'MANUFACTURER', val: 'MANUFACTURER' },
    { lbl: 'PBM', val: 'PBM' },
    { lbl: 'TPA', val: 'TPA' },
];

const verityUserTypeOptions = [
    { lbl: 'WHOLESALER', val: 'WHOLESALER' },
    { lbl: 'MANUFACTURER', val: 'MANUFACTURER' },
];

const radioButtonYesNoOptions = [
    { lbl: 'Yes', val: 'true' },
    { lbl: 'No', val: 'false' },
];

const pbmExtractIntervalOptions = (): ValidOption[] => {
    const options = [] as ValidOption[];
    for (let i = 1; i <= 30; i++) {
        options.push({
            lbl: i.toString(),
            val: i.toString(),
        });
    }
    return options;
};
const pbmBenefitLevelOptions = (): ValidOption[] => {
    const options = [] as ValidOption[];
    for (let i = 1; i <= 10; i++) {
        options.push({
            lbl: i.toString(),
            val: i.toString(),
        });
    }
    return options;
};

const proxyVendorOptions = [
    { lbl: 'None', val: '' },
    { lbl: 'GHX', val: 'GHX' },
];

// PAGE
export function pageStateVM(): VendorEditPageState {
    return {
        waiting: false,
        init: true,
        title: '',
        isVeritySA: false,
        canEdit: false,
        mode: '',
        id: '',
        isTPA: false,
    };
}

// EDIT FORM
export function editStateVM(): EditStateVendor {
    return {
        init: true,
        waiting: false,
        excludedVINs: [],
    };
}

// this should be inside the repo, its the core API contract
// or we need some kind of AI generated AdminVendorModelDefaults generator
// idea is to keep the data layer (repo) isolated from the UI (hook)
export function modelVM(data?, isVerity?: boolean): AdminVendorModel {
    data = data || {};

    return {
        Id: validPropTextVM('Id', 'ID', data.Id, ''),
        ObjectState: validPropRadioTextVM('ObjectState', 'Status', data.ObjectState, 'ACTIVE', statusOptions),
        Name: validPropTextVM('Name', 'Name', data.Name, ''),
        Type: validPropDroplistTextVM('Type', 'Type', data.Type, 'All', isVerity ? verityUserTypeOptions : typeOptions),
        SupportsEDI: validPropRadioTextVM(
            'SupportsEDI',
            'Supports EDI',
            data.SupportsEDI ? 'true' : 'false',
            'false',
            radioButtonYesNoOptions,
        ),
        ProxyVendor: validPropDroplistTextVM(
            'ProxyVendor',
            'Proxy Vendor',
            data.ProxyVendor,
            undefined,
            proxyVendorOptions,
        ),
        SenderId: validPropTextVM('SenderId', 'Sender ID', data.SenderId, ''),
        ReceiverId: validPropTextVM('ReceiverId', 'Receiver ID', data.ReceiverId, ''),
        ShortPONames: validPropRadioTextVM(
            'ShortPONames',
            'No',
            data.ShortPONames ? 'true' : 'false',
            'false',
            radioButtonYesNoOptions,
        ),
        CSOSSplit: validPropRadioTextVM(
            'CSOSSplit',
            'No',
            data.CSOSSplit ? 'true' : 'false',
            'false',
            radioButtonYesNoOptions,
        ),
        CSOSReceiverId: validPropTextVM('CSOSReceiverId', 'CSO Receiver ID', data.CSOSReceiverId, ''),
        CSOSSenderId: validPropTextVM('CSOSSenderId', 'CSO Sender ID', data.CSOSSenderId, ''),
        CreditReplenish: validPropRadioTextVM(
            'CreditReplenish',
            'No',
            data.CreditReplenish ? 'true' : 'false',
            'false',
            radioButtonYesNoOptions,
        ),
        CreditReplenishId: validPropTextVM('CreditReplenishId', 'Credit Receiver ID', data.CreditReplenishId, ''),
        KeyStr: validPropTextVM('KeyStr', 'Public Key', data.KeyStr, ''),
        PBMExtractInterval: validPropDroplistTextVM(
            'PBMExtractInterval',
            'Extract Interval',
            data?.CashCard?.IncrementalExtractInterval === undefined ||
                data?.CashCard?.IncrementalExtractInterval === null
                ? '15'
                : `${data.CashCard.IncrementalExtractInterval}`,
            undefined,
            pbmExtractIntervalOptions(),
        ),
        PBMBenefitLevel: validPropDroplistTextVM(
            'PBMBenefitLevel',
            'Benefit Level',
            data?.CashCard?.MaxBenefitLevel ? `${data.CashCard.MaxBenefitLevel}` : '10',
            undefined,
            pbmBenefitLevelOptions(),
        ),
        PBMBINItems: validPropMultiTextFieldVM('PBMBINItems', 'BIN List', data?.CashCard?.BIN),
        TPAPharmacies: validPropMultiTextFieldVM('TPAPharmacies', 'Pharmacies', data.Pharmacies),
        WholesalerExcludedVINs: validPropMultiTextFieldVM(
            'WholesalerExcludedVINs',
            'Invoice Review VIN Exclusion List',
            data.ExcludedVINs,
        ),
    };
}
